// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const getCouponList = (props) => {
  let couponList = props.allCouponList;
  if (props.isPlacePerkEnabled && props.isPlacePerks) {
    couponList = props.allCouponList?.filter((coupon) => {
      return coupon.offerType === 'placeperks';
    });
  }

  return couponList;
};

const isDashboardORPerks = (props) => {
  return props.isAccountDashboard || (props.isPlacePerkEnabled && props.isPlacePerks);
};

const styles = css`
  display: flex;
  flex-direction: column;

  .couponList_title {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }

  .couponList_title_text {
    ${(props) => (props.couponSelfHelp ? 'width:100%;' : '')};
  }

  .couponList_iconContainer {
    display: flex;
    flex-direction: row;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }
  .coupon_viewall_tile {
    display: flex;
    justify-content: center;
  }
  .coupon_button_black {
    background-color: ${(props) => props.theme.colors.BLACK};
    color: ${(props) => props.theme.colors.WHITE};
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};

    &.shop-btn {
      width: 150px;
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
      border: none;
      &:hover {
        background: #1a1a1a;
      }
    }
  }
  .couponList_helpIcon {
    text-align: center;
    line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    background: ${(props) => props.theme.colors.PRIMARY.GREEN};
    color: ${(props) => props.theme.colors.WHITE};
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    width: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }

  .coupon_carousel {
    ${(props) => props.couponSelfHelp && props.isMPRAndCSHCouponRedesignEnabled && `width:130%;`}
    margin: 0 -${(props) => props.theme.spacing.ELEM_SPACING.SM};
    ${(props) =>
      props.isPlacePerkEnabled &&
      props.isPlacePerks &&
      `margin-right: 0; margin-left: -${props.theme.spacing.ELEM_SPACING.XS}`};

    .coupon_available_couponNameLbl {
      font-size: ${(props) => props.theme.typography.fontSizes.fs11};
    }
    .couponCard__header_text {
      font-size: ${(props) => props.theme.typography.fontSizes.fs11};
      font-weight: ${(props) => props.theme.fonts.fontWeight.black};
    }
  }

  .coupon_carousel_container {
    margin: 0 -${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .view_all {
    text-align: right;
  }
  .slick-dots li {
    margin: 0 3px;
  }

  .rewards-and-offers-section {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    padding-bottom: 15px;
  }
  .rewards-offers-content {
    align-items: center;
    flex-direction: column;
    padding-top: 18px;
    padding-bottom: 9px;
  }
  .alignCenter {
    display: flex;
    justify-content: center;
  }
  .account-drawer-carousel-new {
    .slick-track {
      display: ${(props) =>
        isDashboardORPerks(props) && getCouponList(props)?.size <= 5 && 'inline-flex'};
      margin: 0px;
    }
    .slick-slider {
      padding: 0;
    }
    .slick-dots {
      justify-content: flex-start;
      margin-left: ${(props) => (props.spcBag || props.spc ? '0' : '25px')};
      ${(props) =>
        isDashboardORPerks(props)
          ? `margin-bottom: -16px; margin-left:${props.theme.spacing.ELEM_SPACING.X};`
          : ''};
    }
    .slick-dots li {
      margin: 0 12px 0 0;
      width: 28px;
      height: 2px;
    }
    .slick-dots li button {
      width: 28px;
      height: 2px;
      padding: 15px;
      margin-top: -15px;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        padding: 10px;
        margin-top: -10px;
      }
    }
    .slick-dots li button:before {
      width: 28px;
      height: 2px;
      border-radius: 0;
      background: #b0b0b0;
    }
    .slick-dots li.slick-active button:before {
      background: ${(props) => props.theme.colorPalette.blue[900]};
      border: none;
    }
    .couponCard__header_text {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    }
  }
  .view-all-offers-link-wrapper {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    margin-bottom: 15px;
  }
  .rewards-empty-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    background: ${(props) => props.theme.colorPalette.white};
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    margin-top: 17px;
    .rewards-heading {
      margin: ${(props) => props.theme.spacing.ELEM_SPACING.LRG} 0px 0px
        ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 400;
      font-size: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      line-height: 22px;
    }
    .rewards-link {
      margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0px
        ${(props) => props.theme.spacing.ELEM_SPACING.LRG}
        ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      text-decoration-thickness: 0.5px;
    }
  }
  /* rewards-link */

  .place-perks-title {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    margin-bottom: 0;
    display: flex;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 34px;
    }
  }
  .bonus-points-title {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    margin-bottom: 0;
    display: flex;
    align-items: center;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};

    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 34px;
    }
  }
  .view-all-place-perks-link {
    display: none;
    @media ${(props) => props.theme.mediaQuery.large} {
      display: block;
      font-weight: ${(props) => props.theme.typography.fontWeights.regular};
      margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }
  &.place-perks-coupons-wrapper {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 0;
      width: 100%;
    }
  }
  .view-all-place-perks-bottom-link {
    display: block;
    font-weight: ${(props) => props.theme.typography.fontWeights.regular};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    margin-top: 20px;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.large} {
      display: none;
    }
  }
  ${(props) =>
    (props.spcBag || props.spc || props.isWallet) &&
    `
  .slick-slider .slick-dots{
    position: relative;
  }
  .slick-slider .slick-dots ul{
    display: block;
    text-align: left;
  }`}
  ${(props) =>
    props.isWallet &&
    `
    .wallet-coupons-header {
      font-family: ${props.theme.typography.fonts.secondary};
      font-size: ${props.theme.typography.fontSizes.fs16};
      font-weight: ${props.theme.typography.fontWeights.semiBold};
      margin-left: 10px;
    }
    .mpr-applied-section{
      margin-bottom:24px;
    }
    .mpr-coupons-header {
      font-family: ${props.theme.typography.fonts.secondary};
      font-size: ${props.theme.typography.fontSizes.fs16};
      font-weight: 600;
      margin-left: 10px;
    }
    .account-drawer-carousel-new .slick-dots {
      margin-left: 9px;
    }

    .coupon-wallet-carousel {
      margin-bottom: 32px;
    }

    @media ${props.theme.mediaQuery.medium} {
      .wallet-coupons-header {
        font-size: ${props.theme.typography.fontSizes.fs16};
      }

      .coupon-wallet-carousel {
        margin-bottom: 22px;
      }

      .coupon-applied,
      .coupon-available {
        display: flex;
        flex-wrap: wrap;
      }
    }
    @media ${props.theme.mediaQuery.large} {
     .coupon-slider {
      ${
        props.couponSelfHelp && props.isMPRAndCSHCouponRedesignEnabled
          ? `width: 28%;`
          : `width: 30%;`
      }
      }
    }
    @media ${props.theme.mediaQuery.smallOnly} {
      .couponCard__container_main .couponCard__body {
        padding: 0px 16px 0px 16px;
      }
      .mpr-coupons-header {
        font-size: ${props.theme.typography.fontSizes.fs14};
      }
      .mpr-applied-section{
        ${
          props.couponSelfHelp && props.isMPRAndCSHCouponRedesignEnabled
            ? `margin-bottom:12px;`
            : ''
        }
      }
    }
    `}
`;

export default styles;
